import { useCallback, useEffect, useRef, useState } from 'react';

import serviceEndpoints from '../../../../api/services/serviceEndpoints';

export const useFetchServiceStatus = () => {
  const [loading, setLoading] = useState();
  const [serviceStatus, setServiceStatus] = useState([]);
  const isMounted = useRef(true);

  const fetchAllServiceStatus = useCallback(async () => {
    setLoading(true);
    if (serviceStatus.length === 0) {
      try {
        const response = await serviceEndpoints.getAllServicesStatus();
        if (response.status === 200) {
          if (isMounted.current) setServiceStatus(response.data);
        }
      } finally {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllServiceStatus().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllServiceStatus]);

  return {
    loading,
    situations: serviceStatus,
  };
};
